module.exports = __webpack_public_path__ + "static/media/SM-MT-1.c479b6ba.mp3";